import axios from "axios"
import { env } from "../constants"

export const list = token => {
    const uri = `${env.startpoint}queues`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const join = (token, data) => {
    const uri = `${env.startpoint}queues`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(error => error.response)
}

export const position = (token, organizationId) => {
    const uri = `${env.startpoint}queues/${organizationId}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const leave = (token, organizationId) => {
    const uri = `${env.startpoint}queues/${organizationId}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.delete(uri, headers).then(response => response).catch(error => error.response)
}
